module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Start":"Anfang","Finish":"Ziel"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/ol/Map.vue
// module id = fo1/
// module chunks = 1